import TWButton from './TWButton';
import TWInput from './TWInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import EventTypeText from './EventTypeText';
import { rowsAndFieldsAndLabelsCO, rowsAndFieldsAndLabelsMX } from '../constants/labels';

const AddressSchema = Yup.object().shape({
  street: Yup.string().min(2, 'Mínimo 2 caracteres').max(100, 'Máximo 100 caracteres').required('Campo requerido'),
  number: Yup.string().min(1, 'Mínimo 1 caracter').max(100, 'Máximo 100 caracteres'),
  intNumber: Yup.string().min(1, 'Mínimo 1 caracter').max(100, 'Máximo 100 caracteres'),
  suburb: Yup.string().min(2, 'Mínimo 2 caracteres').max(100, 'Máximo 100 caracteres').required('Campo requerido'),
  crossStreet: Yup.string().min(2, 'Mínimo 2 caracteres').max(100, 'Máximo 100 caracteres').required('Campo requerido'),
  // zipCode: Yup.string().min(5, '5 caracteres').max(100, '100 caracteres').required('Campo requerido'),
  addresseePhone: Yup.string().min(2, 'Mínimo 2 caracteres').max(100, 'Máximo 100 caracteres').required('Campo requerido'),
  reference: Yup.string().min(2, 'Mínimo 2 caracteres').max(250, 'Máximo 250 caracteres').required('Campo requerido'),
  observations: Yup.string().min(2, 'Mínimo 2 caracteres').max(250, 'Máximo 250 caracteres')
});

const rowsAndFieldsAndLabels = process.env.REACT_APP_COUNTRY === 'MX' ? rowsAndFieldsAndLabelsMX : rowsAndFieldsAndLabelsCO

export default function AddressForm({ initialValues, updateAddress, loading, carrier, trackingCode, brandName, addressString }) {

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: AddressSchema,
    onSubmit: values => {
      console.log('submit')
      updateAddress(values)
    },
  });

  return (
    <div className="mt-6 p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-lg flex flex-col items-center space-x-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="space-y-6 sm:space-y-5 w-full">
          <EventTypeText
            eventType={initialValues.eventType}
            carrier={carrier}
            trackingCode={trackingCode}
            brandName={brandName}
            addressString={addressString}
          />
          {rowsAndFieldsAndLabels.map((row, index) => (
            <div key={'row-' + index} className='flex gap-4 flex-col sm:flex-row'>
              {Object.entries(row).map(([key, value]) => (
                <TWInput
                  key={key}
                  name={key}
                  label={value}
                  value={formik.values[key]}
                  handleChange={formik.handleChange}
                  error={(formik.touched[key] && Boolean(formik.errors[key])) || false}
                  errorMessage={(formik.touched[key] && formik.errors[key]) || ''}
                />
              ))}
            </div>
          ))}
        </div>
        <div className="pt-5">
          <div className="flex justify-end">
            <TWButton label="Confirmar dirección" loading={loading} type="submit"></TWButton>
          </div>
        </div>
      </form>
    </div>
  )
}

